import { render, staticRenderFns } from "./TonosCompanniaTab.vue?vue&type=template&id=9aa769c4&scoped=true&"
import script from "./TonosCompanniaTab.vue?vue&type=script&lang=js&"
export * from "./TonosCompanniaTab.vue?vue&type=script&lang=js&"
import style0 from "./TonosCompanniaTab.vue?vue&type=style&index=0&id=9aa769c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa769c4",
  null
  
)

export default component.exports